import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {setLiveDrawAll, setPrizeIsDrawed} from "modules/lucky-draw/redux";
import LiveDrawPageComponent from "./liveDraw.page";
import {AccessRights} from "lib/constants/accessRights"
import LoadingComponent from "components/loading";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function LiveDrawPageContainer() {
  const history = useHistory();
  const dispatch = useDispatch()
  const hasLuckyDrawViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ));
  const prizes = useSelector(state => state.luckyDraw.liveDraw.prizes)
  const title = useSelector(state => state.luckyDraw.LuckyDrawDetail.luckyDrawTitle)
  const isLuckyDrawInPublished = useSelector(state => state.luckyDraw.LuckyDrawDetail.progress === "published")
  const lang = useSelector(state => state.constant.languages)
  
  useEffect(() => {
    if(!hasLuckyDrawViewAccessRight){
      history.push("/admin/dashboard")
    }
  }, [history, hasLuckyDrawViewAccessRight])

  useEffect(() => {
    if(!isLuckyDrawInPublished){
      history.goBack()
    }
  }, [history, isLuckyDrawInPublished])

  if (!hasLuckyDrawViewAccessRight) return <LoadingComponent />;

  const handleDraw = (id) => {
    dispatch(setPrizeIsDrawed(id))
    dispatch(setLiveDrawAll({id}));
  }

  return (
    <LiveDrawPageComponent
      prizes={prizes}
      handleDraw={handleDraw}
      title={title}
      lang={lang}
    />
  )
}

export default LiveDrawPageContainer;
